import * as React from 'react';
import { cn } from '../../lib/cn';

/**
 * Styled `<textarea>` primitive — shadcn/ui convention on the existing token stack.
 *
 * Visual language matches {@link Input}: same border, radius, focus ring, and
 * placeholder colour. `resize-none` is the default so the textarea fits its
 * container cleanly; callers may override via `className="resize-y"` when
 * resizing is needed.
 *
 * `app-region-no-drag` is required on every interactive element so the
 * Electron window-drag region does not eat clicks (#531 / #804).
 */
export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        className={cn(
          'app-region-no-drag w-full rounded-[var(--radius-md)] border border-crucible-border',
          'bg-transparent px-3 py-2 text-sm text-crucible-fg',
          'placeholder:text-crucible-muted',
          'resize-none transition-colors focus:border-crucible-accent focus:outline-none',
          'disabled:cursor-not-allowed disabled:opacity-40',
          className,
        )}
        {...props}
      />
    );
  },
);
Textarea.displayName = 'Textarea';
